export default __webpack_public_path__ + "static/media/awaiting5.cb327d9f.svg";